import React from "react";

import {
  ConnectedService,
  EditorDisplayOptions,
} from "@/components/editors/EditorDisplay";
import ImageTemplate from "@/components/editors/template-blocks/image/ImageTemplate";
import { SliderTemplate } from "@/components/editors/template-blocks/slider/SliderTemplate";
import VideoTemplate from "@/components/editors/template-blocks/video-old/VideoTemplate";
import { fontFamilyOptions } from "@/models/editors/editor";
import { ImageTypeTemplate } from "@/states/page-editor/template-parts/image";
import { TemplatePart } from "@/states/page-editor/template-parts/types";

export interface MainBlockProps {
  part: TemplatePart;
  options?: EditorDisplayOptions;
  connectedService: ConnectedService | undefined;
}

/**
 * メインブロック
 * @returns
 */
const MainBlock: React.FC<MainBlockProps> = ({
  part,
  options,
  connectedService,
  ...other
}) => {
  return (
    <div className="-mx-4 w-auto md:mx-0">
      <div
        className="flex w-full text-center place-content-center"
        style={{ fontFamily: fontFamilyOptions[0].value }}
        {...other}
      >
        <div className="w-full md:w-[920px]">
          <TemplateRenderer
            part={part}
            options={options}
            connectedService={connectedService}
          />
        </div>
      </div>
    </div>
  );
};

interface TemplateRendererProps {
  part: TemplatePart;
  options?: EditorDisplayOptions;
  connectedService: ConnectedService | undefined;
}

function TemplateRenderer({ part, options }: TemplateRendererProps) {
  switch (part.type) {
    case "image":
      return <ImageTemplate part={part as ImageTypeTemplate} />;
    case "slider":
      return <SliderTemplate part={part} />;
    case "video":
      return <VideoTemplate part={part} />;
    default:
      return (
        <ImageTemplate
          part={part as ImageTypeTemplate}
          formPath={options?.partsProps?.ctaButtonService?.formPath}
          confirmPath={options?.partsProps?.ctaButtonService?.confirmPath}
        />
      );
  }
}

export default MainBlock;
